import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import InfoIcon from '@mui/icons-material/Info';
import { Link, Stack } from '@mui/material';

import { CONFIG } from '@arrived/config';

import { ArrivedTooltip, ArrivedTooltipProps } from '../../tooltips';

interface PortfolioEquityTooltipProps extends Omit<ArrivedTooltipProps, 'children'> {
  children?: ReactNode;
}

export const PortfolioEquityTooltip = ({ children, ...tooltipProps }: PortfolioEquityTooltipProps) => {
  return (
    <ArrivedTooltip
      title={
        <Stack direction="row" alignItems="center" gap={0.5}>
          <InfoIcon fontSize="inherit" />
          {children}
        </Stack>
      }
      leaveDelay={200}
      {...tooltipProps}
    >
      <FormattedMessage
        id="portfolio.equity.tooltip"
        values={{
          br: <br />,
          learnLink: (parts: any) => (
            <Link
              fontSize="inherit"
              href={`${CONFIG.learnBlogUrl}/property-share-prices`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {parts}
            </Link>
          ),
        }}
      />
    </ArrivedTooltip>
  );
};
